import { colors } from 'plume-ui'
import React, { FC } from 'react'
import { css } from '@emotion/react'
import listenToClickOutside from 'react-onclickoutside'

import { CB_LATEST_ROUND_TYPE_OPTIONS } from '../../constants/options'
import { ConditionName, Option } from '../../actions'
import { OptionDropdown } from '@/components/view/OptionDropdown'
import { formatCondition } from '../../utils'
import { SelectConditionName } from '../../constants/conditions'
import { Button } from './Condition'

type Props = {
  open: boolean
  name: SelectConditionName
  selected: Option[]
  onSelectOption: (cond: ConditionName, option: Option) => any
  onToggle: (cond: ConditionName) => any
  onRemove: (cond: ConditionName) => any
}

const ListItem: FC<{
  option: Option
  onSelect: () => void
  label: string
  selected: Option[]
}> = ({ option, onSelect, label, selected }) => {
  const isSelected = selected.includes(option as any)
  return (
    <li
      css={css`
        height: 30px;

        &:hover {
          background-color: ${colors.backgroundGray};
        }
      `}
    >
      <a
        key={option}
        onClick={onSelect}
        css={css`
          list-style: none;
          display: flex;
          gap: 10px;
          height: 100%;
          align-items: center;
          font-size: 14px;
          line-height: 18px;
          padding: 0 10px;
          cursor: pointer;
        `}
      >
        {isSelected ? (
          <i
            className={'icomoon icon-check1'}
            css={css`
              flex-shrink: 1;
              min-width: 14px;
            `}
          />
        ) : (
          <span
            css={css`
              flex-shrink: 1;
              min-width: 14px;
            `}
          ></span>
        )}
        {label}
      </a>
    </li>
  )
}

export class CrunchbaseLatestRoundTypeCondition extends React.Component<Props> {
  handleClickOutside() {
    if (this.props.open) {
      this.props.onToggle(this.props.name)
    }
  }

  render() {
    const { selected, onSelectOption, open, name } = this.props
    return (
      <div
        className="condition"
        css={css`
          background-color: ${colors.cyan50};
          border-radius: 50px;
          color: ${colors.white10};
          display: inline-block;
          font-size: 13px;
          position: relative;
          &:last-child {
            margin-right: 5px;
          }
        `}
      >
        <button
          className="condition-label"
          onClick={() => this.props.onToggle(this.props.name)}
          css={css`
            border: inherit;
            background: transparent;
            color: inherit;
            padding: 5px 10px 5px 15px;
            cursor: pointer;
          `}
        >
          <span
            css={css`
              padding-right: 5px;
            `}
          >
            {formatCondition(name, selected)}
          </span>
          <Button
            selected={selected}
            onClick={() => this.props.onRemove(this.props.name)}
          />
        </button>
        <OptionDropdown open={open}>
          <ul
            css={css`
              margin: 0;
              padding: 0;
              list-style: none;
            `}
          >
            {Object.entries(CB_LATEST_ROUND_TYPE_OPTIONS)
              .filter(([_, value]) => !value.isOther)
              .map(([key, option]) => (
                <ListItem
                  key={key}
                  option={key as Option}
                  onSelect={() =>
                    onSelectOption('cbLatestRoundType', key as any)
                  }
                  selected={selected}
                  label={option.label}
                />
              ))}
            <li
              css={css`
                cursor: pointer;

                &:hover {
                  background-color: ${colors.backgroundGray};

                  div.dropdown {
                    visibility: visible;
                    opacity: 1;
                  }
                }
              `}
            >
              <span
                css={css`
                  position: relative;
                  height: 30px;
                  list-style: none;
                  display: flex;
                  gap: 10px;
                  width: 100%;
                  align-items: center;
                  font-size: 14px;
                  line-height: 18px;
                  padding: 0 34px;
                `}
              >
                その他
                <i
                  className="icon-arrow7-right"
                  css={css`
                    position: absolute;
                    left: 86%;
                    top: 30%;
                  `}
                />
              </span>
              <div
                className="dropdown"
                css={css`
                  padding: 5px 0;
                  bottom: -50px;
                  left: 204px;
                  position: absolute;
                  visibility: hidden;
                  opacity: 0;
                  background: ${colors.white00};
                  color: ${colors.text};
                  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
                  transition: opacity 0.3s ease;
                `}
              >
                <ul
                  css={css`
                    padding: 0;
                    margin: 0;
                    list-style: none;
                  `}
                >
                  {Object.entries(CB_LATEST_ROUND_TYPE_OPTIONS)
                    .filter(([_, value]) => value.isOther)
                    .map(([key, option]) => (
                      <ListItem
                        key={key}
                        option={key as Option}
                        onSelect={() =>
                          onSelectOption('cbLatestRoundType', key as any)
                        }
                        selected={selected}
                        label={option.label}
                      />
                    ))}
                </ul>
              </div>
            </li>
          </ul>
        </OptionDropdown>
      </div>
    )
  }
}

export default listenToClickOutside(CrunchbaseLatestRoundTypeCondition)
